import { MenuLink } from "../shared/interface/bcmenulink";

const menu: MenuLink[] = [
  {
    iconLink: "home",
    path: "/",
    label: "Inicio",
  },
  {
    iconLink: "book",
    path: "/piramide",
    label: "Piramide",
  },
  {
    iconLink: "book",
    path: "/one-pager",
    label: "One Pager",
  },
  {
    iconLink: "book",
    path: "/history",
    label: "History",
  },
];

export { menu };